/**
 * App nativa: i numeri in italiano raggruppano le migliaia anche a 4 cifre (3.116,00 invece di 3116,00).
 * Il locale it-IT lo omette di default; qui lo si forza per ogni formato italiano (Intl.NumberFormat e Number#toLocaleString),
 * così tutte le pagine mostrano gli importi nello stesso modo. Sul web/desktop non si installa.
 */
type Opts = Intl.NumberFormatOptions | undefined;

const isItalian = (l: unknown) => {
  const loc = Array.isArray(l) ? l[0] : l;
  return typeof loc === "string" && loc.toLowerCase().startsWith("it");
};
const withGrouping = (o: Opts): Opts =>
  (o as { useGrouping?: unknown } | undefined)?.useGrouping === undefined
    ? ({ ...(o ?? {}), useGrouping: "always" } as unknown as Intl.NumberFormatOptions)
    : o;

export function installItalianGrouping() {
  try {
    const Orig = Intl.NumberFormat;
    const Patched = function (this: unknown, locales?: string | string[], options?: Opts) {
      return new Orig(locales, isItalian(locales) ? withGrouping(options) : options);
    } as unknown as typeof Intl.NumberFormat;
    Object.defineProperty(Patched, "prototype", { value: Orig.prototype });
    Patched.supportedLocalesOf = Orig.supportedLocalesOf.bind(Orig);
    Intl.NumberFormat = Patched;

    const origToLocale = Number.prototype.toLocaleString;
    Number.prototype.toLocaleString = function (this: number, locales?: string | string[], options?: Opts) {
      return origToLocale.call(this, locales, isItalian(locales) ? withGrouping(options) : options);
    };
  } catch {
    /* ambiente senza Intl modificabile: si resta sul comportamento standard */
  }
}
